import React, {Component} from 'react';
import {Container, Loader, Form, Grid, Segment} from 'semantic-ui-react';
import {connect} from 'react-redux';
import _ from 'lodash';
import ApiActions from 'go/actions/api';
import {
  API_CONFIG_GET_SUCCESS,
  API_ORG_GET_BY_USER_SUCCESS,
  API_ORG_GET_BY_ID_SUCCESS,
  API_ORGS_LIST_GET_BY_ID_SUCCESS,
} from 'common/types';
import {
  ASSOCIATED_ENTITY_STATUSES,
  ORG_REL_TYPE_MAP,
} from 'app-ui-componentlibrary/dist/common/constants';
import {GRANT_WRITER_ROLE, AOR_ROLE} from 'go/components/organization/team/constants';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Alert} from 'componentLibrary';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import GrantsFilterResults from './GrantsFilterResults';
import REST from 'go/requests/rest';
import {Toggle} from 'componentLibrary';

import {
  InlineSelect,
  RadioField,
  Select,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import PermissionsUtility from 'go/security/permissionsUtility';
import {SUBORG_GRANT_MANAGE_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {subApplicationsToSubGrantsFilter, getSubOrganizationId} from 'common/utils';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

const SEARCH_OPTIONS = {
  INITIAL: 'start',
  IN_PROGRESS: 'inprogress',
  SUCCESS: 'success',
  ERROR: 'error',
  DEFAULT: 'title',
};

const DEFAULT_FILTERS = [
  {filter: 'sortBy', value: 'displayName'},
  {filter: 'sortDir', value: 'ASC'},
];

const EMPTY_FILTER = [{key: '', value: null, text: ''}];

const LOCAL_STORAGE_KEY = 'subOrgGrants';

export class _SubOrgGrants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allOrgs: [],
      configName: 'grantsConfig',
      subGrantConfigs: {},
      currentOrganization: {},
      error: false,
      filterKey: '',
      filters: {},
      searchString: {applicationTitle: '', displayName: ''},
      filterValue: '',
      grants: [],
      grantChecked: false,
      grantWriterEntityIds: [],
      loading: true,
      noOrgsFound: false,
      organizationChanged: true,
      orgPrograms: null,
      projectsChecked: false,
      sortOptions: {sortBy: 'fiscalYr', sortDir: 'asc'}, // Default sort
      subappTitleSearchString: '',
      subOrgNameSearchString: '',
    };
  }

  componentDidMount() {
    document.title = SUBORG_GRANT_MANAGE_PAGE;
    const {token} = this.props;
    const permissionData = new PermissionsUtility(token);
    const {permissions} = permissionData;
    const gw_EntityIds = [];
    const allEntityIds = [];

    permissions.sort().forEach((org) => {
      const [entityId, orgIdentifier, roleId] = org.split(':');
      allEntityIds.push(entityId);

      if (parseInt(roleId) === GRANT_WRITER_ROLE) {
        const [orgId, programId, subOrgId] = orgIdentifier.split('_');
        gw_EntityIds.push({
          hideOrgId: orgId,
          hideProgramId: programId,
          hideSubOrgId: subOrgId,
        });
      }
    });

    this.setState({grantWriterEntityIds: gw_EntityIds});
    if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
      this.getEntititesForUsers();
    } else {
      this.initWithOrganizations();
    }
  }

  _getConfigByCategoryId = (items) => {
    var cloneConfigs = _.clone(this.state.subGrantConfigs);
    let promises = [];
    var config = _.map(items, (item) => {
      const {foId, entityType, configName} = item;
      if (!cloneConfigs[foId]) {
        promises.push(
          new Promise((resolve, reject) => {
            this.props
              .getConfigByCategoryId(
                this.props.token,
                entityType,
                foId,
                'objectDefinition',
                configName
              )
              .then((res) => {
                if (res && res.type === API_CONFIG_GET_SUCCESS) {
                  cloneConfigs[foId] = res.payload;
                  this.setState({subGrantConfigs: cloneConfigs});
                }
                return resolve();
              });
          })
        );
      }
    });
    return Promise.all(promises);
  };

  initWithOrganizations = () => {
    this.props
      .getOrgs(this.props.token)
      .then((res) => {
        if (res && res.type === API_ORG_GET_BY_USER_SUCCESS) {
          if (res.payload.length) {
            let sortedResults = _.head(_.sortBy(res.payload, 'displayName'));
            this.setState({
              allOrgs: res.payload,
              currentOrganization: sortedResults,
              error: false,
              noOrgsFound: false,
            });
          } else {
            this.setState({
              noOrgsFound: true,
            });
          }
        } else {
          this.setState({
            noOrgsFound: true,
          });
        }
        return res;
      })
      .then((res) => {
        this.getOrgsGrantsCurrent(
          this.state.currentOrganization.entityId,
          DEFAULT_FILTERS
        );
      })
      .catch((err) => {
        console.error('error');
        this.setState({
          loading: false,
          error: true,
        });
      });
  };

  getEntititesForUsers = () => {
    this.setState({isLoaded: false}, () => {
      REST.user
        .getEntities(this.props.token)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            if (this.props.pageEntityType === 'grant') {
              let sortedResults = _.head(_.sortBy(response, 'displayName'));
              this.setState({
                allOrgs: response,
                currentOrganization: sortedResults,
                error: false,
                isLoaded: true,
                isSuborgLoaded: true,
                noOrgsFound: false,
                suborgsAllowed: true,
                userEntities: response,
              });
            }

            let OrgListCanHaveSuborg = [];
            response.forEach((entityListDescr) => {
              if (entityListDescr.canHaveSuborganizations) {
                OrgListCanHaveSuborg.push(entityListDescr);
              }
            });
            let sortedResults = _.head(_.sortBy(OrgListCanHaveSuborg, 'displayName'));
            this.setState({
              allOrgs: OrgListCanHaveSuborg,
              currentOrganization: sortedResults,
              error: false,
              isLoaded: true,
              isSuborgLoaded: true,
              noOrgsFound: false,
              suborgsAllowed: true,
              userEntities: OrgListCanHaveSuborg,
            });
          } else if (response.status === 404) {
            return [];
          } else {
            this.setState({
              error: true,
              isLoaded: true,
            });
          }
        })
        .then((res) => {
          this.getOrgsGrantsCurrent(
            this.state.currentOrganization.entityId,
            DEFAULT_FILTERS
          );
        })
        .catch((err) => {
          console.error('error');
          this.setState({
            loading: false,
            error: true,
          });
        });
    });
  };

  getEntitiesDataById = (entityId) => {
    let entityListDescr = [];
    let entityInfo;
    this.setState({isLoaded: false}, () => {
      REST.user
        .getEntities(this.props.token)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            response.forEach((entityListDescr) => {
              entityInfo = _.includes(entityListDescr.entityId, entityId);
              if (entityInfo) {
                this.setState({
                  currentOrganization: {
                    canHaveSuborganizations: entityListDescr.canHaveSuborganizations,
                    displayName: entityListDescr.displayName,
                    entityId: entityListDescr.entityId,
                    entityRelationshipType: entityListDescr.entityRelationshipType,
                  },
                });

                this.getSubAppsBasedOnToggle(
                  this.props.toggles,
                  this.state.currentOrganization,
                  null
                );
              }
            });
          } else if (response.status === 404) {
            return [];
          } else {
            this.setState({
              error: true,
              isLoaded: true,
            });
          }
        });
    });
  };

  getOrgsGrantsCurrent = (entityId) => {
    if (entityId) {
      if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
        this.getEntitiesDataById(entityId);
      } else {
        this.props
          .getOrgById(this.props.token, entityId)
          .then((res) => {
            if (res.type === API_ORG_GET_BY_ID_SUCCESS) {
              this.setState({
                currentOrganization: {
                  entityId: res.payload.organizationId,
                  displayName: res.payload.displayName,
                },
              });

              var submitted = 'applicant';
              this.fetchSubApplicationDataV1(submitted, null);
            }
          })
          .catch((err) => {
            console.error('error fetching current org ');
          });
      }
    }
  };

  handleOrgChange = (e) => {
    this.setState({
      organizationChanged: true,
      loading: true,
      grantChecked: false,
      projectsChecked: false,
      filters: {},
    });
    this.getOrgsGrantsCurrent(e.target.value, DEFAULT_FILTERS);
  };

  adaptTextString = (strValue) => {
    return _.get(ASSOCIATED_ENTITY_STATUSES, strValue);
  };

  applySort = (grants) => {
    const {sortOptions} = this.state;
    let sortedGrants = [];
    sortedGrants = _.sortBy(grants, [sortOptions.sortBy]); // grantId is a tie breaker
    if (_.get(sortOptions, 'sortDir', '').toLowerCase() === 'desc') {
      sortedGrants = _.reverse(sortedGrants);
    }
    return sortedGrants;
  };

  getSubAppsBasedOnToggle = (toggles, currentOrganization, grants) => {
    const {token} = this.props;

    if (_.includes(toggles, 'manageTeamOrgSubOrg')) {
      if (
        currentOrganization.entityRelationshipType !==
        ORG_REL_TYPE_MAP.NOT_PARENT_ORG_OR_SUBORG.code
      ) {
        const permissionUtil = new PermissionsUtility(this.props.token);
        let parentList = permissionUtil.getParentOrgIdForSubOrg(
          currentOrganization.entityId
        );
        let isSelectedOrgForEntityOneAndFive = permissionUtil.isCurrentIdExistForEntityOneAndFive(
          currentOrganization.entityId,
          this.props.token
        );
        if (currentOrganization.canHaveSuborganizations) {
          this.fetchSubAppData(
            'applicant',
            null,
            grants,
            'getSubAppsByOrgIdAndByCategoryId',
            'getSubAppsByOrgIdAndByProgramId',
            'getSubGrantsByOrgId'
          );
        }
      }
    } else {
      this.fetchSubApplicationDataV1('self', grants);
    }
  };

  getStoredFilters = () => {
    const {id} = this.props;
    const filter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
    if (filter) {
      if (filter.userId !== id) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}));
      } else return filter;
    }
    return {};
  };

  fetchSubAppData = (
    submitted,
    parentOrgIds,
    allGrants,
    searchByCategoryCall,
    searchByProgramCall,
    subGrantCall
  ) => {
    const {organizationChanged, currentOrganization} = this.state;
    const organizationId = currentOrganization.entityId;
    let subOrgId;

    const filter = this.getStoredFilters();
    if (organizationChanged) {
      const {token} = this.props;
      this.setState({
        organizationChanged: false,
        filter: filter,
        programCategoryIds: [],
        grants: allGrants,
        programId: {},
        allGrants: allGrants,
      });

      REST.ref
        .getTypesByItemCodes(token)
        .then((response) => {
          return forceJsonResponse(response, FLUX);
        })
        .then((itemData) => {
          this.setState({
            refItem: itemData,
          });
        })
        .then((res) => {
          const permissionUtil = new PermissionsUtility(this.props.token);
          permissionUtil
            .getProgramIdAndCategoryIdByOrgId(this.props.token, organizationId)
            .then((res) => {
              if (!_.isEmpty(res)) {
                this.setState({
                  eligibleProgramIds: res.eligibleProgramIds,
                  programCategoryIds: _.uniq(res.programCategoryIds),
                });
              }
              if (this.state.programCategoryIds.length > 0) {
                try {
                  let promises = [];
                  _.forEach(this.state.eligibleProgramIds, (programId) => {
                    promises.push(
                      REST.search[searchByProgramCall](
                        this.props.token,
                        organizationId,
                        null,
                        parentOrgIds,
                        programId,
                        submitted
                      )
                    );
                  });
                  _.forEach(this.state.programCategoryIds, (categoryId) => {
                    promises.push(
                      REST.search[searchByCategoryCall](
                        this.props.token,
                        organizationId,
                        null,
                        parentOrgIds,
                        categoryId,
                        submitted
                      )
                    );
                  });

                  const response = Promise.all(promises)
                    .then((results) => {
                      const successResults = _.filter(
                        results,
                        (result) => result.status === 200
                      );
                      return Promise.all(successResults.map((r) => r.json()));
                    })
                    .then((results) => {
                      if (!_.isEmpty(results)) {
                        const resItems = _.uniqBy(
                          _.flatMap(results, (result) => result.items),
                          'entityId'
                        );
                        const subGrantResponse = REST.search[subGrantCall](
                          this.props.token,
                          organizationId,
                          null,
                          parentOrgIds,
                          submitted
                        )
                          .then((subGrantRes) => {
                            if (subGrantRes.status === 200) {
                              return forceJsonResponse(subGrantRes, FLUX);
                            } else {
                              return Promise.resolve({items: []});
                            }
                          })
                          .then((subGrantJson) => {
                            let _items = JSON.parse(JSON.stringify(resItems));

                            // replace subapp with subgrant if it exists
                            _items = subApplicationsToSubGrantsFilter(
                              _items,
                              subGrantJson.items
                            );

                            // At this point allGrants has all

                            // Not sure if we need this
                            subOrgId = _.uniq(
                              _.map(_items, (grant) => getSubOrganizationId(grant))
                            );

                            let subOrganizationsDetails = [];
                            if (!_.values(subOrgId).every(_.isUndefined)) {
                              this.props
                                .organizations(subOrgId, this.props.token)
                                .then((res) => {
                                  if (res.type === API_ORGS_LIST_GET_BY_ID_SUCCESS) {
                                    // Get Suborganization Information
                                    res.payload.forEach((result) => {
                                      subOrganizationsDetails.push({
                                        entityId: result.organizationId,
                                        displayName: result.displayName,
                                      });
                                    });

                                    let grantConfigItems = [];
                                    // put payload.applicationTypeDescription in root of object for easier sorting and filtering
                                    let _enhancedItems = _.forEach(_items, (item) => {
                                      let _itemDisplayName = _.find(
                                        subOrganizationsDetails,
                                        {
                                          entityId: parseFloat(
                                            getSubOrganizationId(item)
                                          ),
                                        }
                                      );
                                      _.assign(item, {
                                        applicationTypeDescription:
                                          item.payload.applicationTypeDescription,
                                        applicationTitle: item.payload.applicationTitle,
                                        displayName: _itemDisplayName.displayName,
                                      });
                                      if (item.categoryId === 406) {
                                        grantConfigItems.push({
                                          foId: 406,
                                          entityType: 'pc',
                                          configName: 'grantsConfig',
                                        });
                                      } else {
                                        grantConfigItems.push({
                                          foId: item.fundingOpportunityId,
                                          entityType: 'fo',
                                          configName: 'subGrantConfig',
                                        });
                                      }
                                    });
                                    let confItems = _.uniqBy(grantConfigItems, 'foId');
                                    this.setState({
                                      searching: SEARCH_OPTIONS.SUCCESS,
                                      grants: _.sortBy(_enhancedItems, 'displayName'),
                                      projects: JSON.parse(JSON.stringify(resItems)),
                                      allGrants: _.sortBy(_enhancedItems, 'displayName'),
                                    });

                                    this.decorateFilters(_enhancedItems);

                                    // Set state for ORganization Details
                                    this.setState(
                                      {subOrganizationsDetails: subOrganizationsDetails},
                                      () => {
                                        this._getConfigByCategoryId(confItems).then(
                                          (res) => {
                                            if (res) {
                                              this.setState({
                                                loading: false,
                                              });
                                            }
                                          }
                                        );
                                      }
                                    );
                                  } else {
                                    this.setState({
                                      loading: false,
                                    });
                                  }
                                });
                            } else {
                              this.setState({
                                loading: false,
                              });
                            }
                          });
                      } else {
                        // Organization does not have grants
                        this.setState({
                          allGrants: [],
                          grants: [],
                          loading: false,
                        });
                      }
                    });
                } catch (error) {
                  this.setState({
                    searching: SEARCH_OPTIONS.ERROR,
                    data: [],
                  });
                }
              } else {
                this.setState({
                  loading: false,
                });
              }
            });
        });
    } else {
      this.doFilters();
    }
  };

  loadFromLocalStorage = () => {
    const item = this.getStoredFilters();
    const {
      applicationTitle,
      displayName,
      applicationTypeDescription,
      status,
      sortBy,
      sortDir,
    } = item;
    if (applicationTitle !== '') {
      this.setFilter('applicationTitle', applicationTitle);
    }
    if (displayName !== '') {
      this.setFilter('displayName', displayName);
    }
    if (applicationTypeDescription !== '') {
      this.setFilter('applicationTypeDescription', applicationTypeDescription);
    }
    if (status !== '') {
      this.setFilter('status', status);
    }
    if (sortBy !== '') {
      this.handleSortChange('sortBy', sortBy);
    }
    if (sortDir !== '') {
      this.handleSortChange('sortDir', sortDir);
    }
  };

  decorateFilters = (_enhancedItems) => {
    let _filterOptions = {
      filterSubAppType: _.clone(EMPTY_FILTER),
      filterSubAppStatus: _.clone(EMPTY_FILTER),
    };
    // get values for SubApplication Type filter
    let _filterSubAppType = _.uniq(
      _.map(_enhancedItems, (subapp) => subapp.payload.applicationTypeDescription)
    );

    // get values for SubApplication Type Status
    let _filterSubAppStatus = _.uniq(_.map(_enhancedItems, (subapp) => subapp.status));
    _.each(_.sortBy(_filterSubAppType), (val) => {
      _filterOptions.filterSubAppType.push({
        key: val,
        value: val,
        text: val,
      });
    });
    _.each(_.sortBy(_filterSubAppStatus), (val) => {
      _filterOptions.filterSubAppStatus.push({
        key: val,
        value: val,
        text: this.adaptTextString(val),
      });
    });
    this.setState({filterOptions: _filterOptions});

    this.loadFromLocalStorage();
  };

  doFilters = () => {
    const {allGrants, grants, filters, searchString} = this.state;

    let cleanedFilters = _.pickBy(filters, _.identity);
    let filteredGrants;

    // filter values
    filteredGrants = _.filter(allGrants, cleanedFilters);

    // filter using search terms search subapplication title or name
    filteredGrants = _.filter(filteredGrants, (item) => {
      if (
        _.includes(
          _.toLower(item.applicationTitle),
          _.toLower(searchString.applicationTitle)
        ) &&
        _.includes(_.toLower(item.displayName), _.toLower(searchString.displayName))
      ) {
        return item;
      }
    });

    this.setState({
      grants: this.applySort(filteredGrants),
      loading: false,
      error: false,
    });
  };

  setFilter = (name, value) => {
    if (name === 'applicationTitle' || name === 'displayName') {
      this.setState(
        (prevState) => ({
          searchString: {
            ...prevState.searchString,
            [name]: value,
          },
        }),
        () => {
          // gets called after the filter state is updated
          this.fetchSubAppData('applicant', null);
        }
      );
    } else {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            [name]: value,
          },
        }),
        () => {
          // gets called after the filter state is updated
          this.fetchSubAppData('applicant', null);
        }
      );
    }
    // This sets the state so the value appears in the form element
  };

  renderOrgDropdown = () => {
    const {allOrgs, currentOrganization} = this.state;
    const {toggles} = this.props;

    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const ueiEftFormat =
      currentOrganization.uei +
      (!_.isEmpty(_.trim(currentOrganization.eft))
        ? '-' + _.trim(currentOrganization.eft)
        : '');
    const ueiEft = currentOrganization.uei ? ' ' + ueiEftFormat : '';

    let sortedOrgs = _.sortBy(allOrgs, 'displayName');

    if (allOrgs && allOrgs.length === 1) {
      return dunsToUEIToggle ? (
        <Grid.Column>
          <h4>{currentOrganization.displayName + ueiEft || sortedOrgs[0].displayName}</h4>
        </Grid.Column>
      ) : (
        <Grid.Column>
          <h4>{currentOrganization.displayName || sortedOrgs[0].displayName}</h4>
        </Grid.Column>
      );
    } else if (allOrgs && allOrgs.length > 1) {
      return (
        <React.Fragment>
          <Grid.Column key="selectOrgFormColumn" width={5} className="org-select-label">
            <h5>
              <label htmlFor="orgSelect">Select an organization</label>
            </h5>
            <Form>
              <Select
                className={'select-organization'}
                handleChange={this.handleOrgChange}
                id={'orgSelect'}
                key="selectOrgForm"
                name={'orgSelect'}
                placeholder=""
                search
                selection
                title="Select an organization"
                value={currentOrganization.entityId}
                options={_.map(sortedOrgs, (entry, index) => {
                  return dunsToUEIToggle
                    ? {
                        value: entry.entityId,
                        text:
                          entry.displayName +
                          (entry.uei
                            ? !_.isEmpty(_.trim(entry.eft))
                              ? ' ' + entry.uei + '-' + entry.eft
                              : ' ' + entry.uei
                            : ''),
                      }
                    : {
                        value: entry.entityId,
                        text: entry.displayName,
                      };
                })}
              />
            </Form>
          </Grid.Column>
        </React.Fragment>
      );
    }
  };

  handleSortChange = (name, value) => {
    let sortOptions = _.get(this.state, 'sortOptions', {});
    sortOptions[name] = value;
    this.setState({loading: true, sortOptions: sortOptions}, () => {
      var submitted = 'applicant';
      this.fetchSubAppData(submitted, null);
    });
  };

  handleLocalStorageChange = (userEnteredChanges, storageKey) => {
    const {id} = this.props;
    const userStoredFilters = this.getStoredFilters();

    const filter = userStoredFilters;
    let value;
    if (userEnteredChanges === '') {
      _.unset(userStoredFilters, storageKey);
      value = userStoredFilters;
    } else {
      value = _.set(filter, storageKey, userEnteredChanges);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({...value, userId: id}));
  };

  renderFilter = () => {
    const {filterOptions, filters, sortOptions, searchString} = this.state;
    return (
      <Toggle toggle="ReviewByRecipientTaskNav">
        <Grid.Column key="gridSubAppFiltersColumn">
          <Form key="grantsSubAppFilterForm">
            <h3>Search</h3>
            <TextBoxField
              key="subAppTitleSearchTextBox"
              title="Search by grant ID"
              label="Subapplication title"
              id="searchTitle"
              value={searchString.applicationTitle || ''}
              handleChange={(e) => {
                this.setFilter('applicationTitle', e.target.value);
                this.handleLocalStorageChange(e.target.value, 'applicationTitle');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Backspace') {
                  this.setFilter('applicationTitle', e.target.value);
                }
              }}
            />
            <TextBoxField
              key="subAppNameSearchTextBox"
              title="Search by grant ID"
              label="Suborganization name"
              id="searchSubOrgName"
              value={searchString.displayName || ''}
              handleChange={(e) => {
                this.setFilter('displayName', e.target.value);
                this.handleLocalStorageChange(e.target.value, 'displayName');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Backspace') {
                  this.setFilter('displayName', e.target.value);
                }
              }}
            />
            <h3>Filters</h3>
            <InlineSelect
              key="applicationTypeDescription"
              id="applicationTypeDescription"
              label="Subapplication type"
              labeled="true"
              search
              selection
              title="Filter by grant program"
              name="applicationTypeDescription"
              value={filters.applicationTypeDescription || ''}
              handleChange={(e) => {
                this.setFilter(e.target.name, e.target.value);
                this.handleLocalStorageChange(
                  e.target.value,
                  'applicationTypeDescription'
                );
              }}
              options={filterOptions ? filterOptions.filterSubAppType : []}
            />

            <Toggle toggle="grantFilters">
              <InlineSelect
                key="grantStatusSelect"
                id="grantStatus"
                label="Status"
                labeled="true"
                search
                selection
                title="Filter by Grant Status"
                name="status"
                value={filters.status || ''}
                handleChange={(e) => {
                  this.setFilter(e.target.name, e.target.value);
                  this.handleLocalStorageChange(e.target.value, 'status');
                }}
                options={filterOptions ? filterOptions.filterSubAppStatus : []}
              />
            </Toggle>
            <h3>Sort</h3>
            <InlineSelect
              key="grantSortBySelect"
              search
              selection
              title="Sort"
              name="sortBy"
              id="sortBy"
              label="Sort by"
              value={sortOptions.sortBy}
              handleChange={(e) => {
                this.handleSortChange(e.target.name, e.target.value);
                this.handleLocalStorageChange(e.target.value, 'sortBy');
              }}
              options={[
                {key: '', value: null, text: ''},
                {
                  key: 'displayName',
                  value: 'displayName',
                  text: 'Suborganization name',
                },
                {
                  key: 'status',
                  value: 'status',
                  text: 'Status',
                },
                {
                  key: 'statusDate',
                  value: 'statusDate',
                  text: 'Status date',
                },
              ]}
            />
            <Form.Field>
              <RadioField
                key="grantSortDirRadio"
                name="sortDir"
                id="sortDir"
                value={sortOptions.sortDir}
                handleChange={(e) => {
                  this.handleSortChange(e.target.name, e.target.value);
                  this.handleLocalStorageChange(e.target.value, 'sortDir');
                }}
                options={[
                  {label: 'Ascending (A-Z)', value: 'asc'},
                  {label: 'Descending (Z-A)', value: 'desc'},
                ]}
              />
            </Form.Field>
          </Form>
        </Grid.Column>
      </Toggle>
    );
  };

  renderGrants = () => {
    const {grants, allGrants} = this.state;
    return (
      <Grid.Column width={12}>
        {allGrants && allGrants.length > 0 ? (
          <GrantsFilterResults
            subGrantConfigs={this.state.subGrantConfigs}
            currentOrg={this.state.currentOrganization}
            data={grants}
            grantAppExt={this.state.grantAppExtensions}
            grantWriterEntityIds={this.state.grantWriterEntityIds}
            key="grantsFilterResults"
            pageEntityType={this.props.pageEntityType}
            refItems={this.state.refItem}
            subOrganizationsDetails={this.state.subOrganizationsDetails}
            token={this.props.token}
          />
        ) : this.props.pageEntityType === 'subgrant' ? (
          <Alert header="No Subapplications Found" type="info">
            <p>
              Currently there are no suborganizations applications for your organization.
            </p>
          </Alert>
        ) : (
          <Alert header="No Subapplications Found" type="info">
            <p>There are no grants associated with your organization.</p>
          </Alert>
        )}
      </Grid.Column>
    );
  };

  render() {
    const {loading, error, noOrgsFound} = this.state;
    const sortReorder = _.includes(this.props.toggles, 'disasterSiteNav');
    if (error) return <Error />;

    return (
      <Main>
        <Container fluid>
          {noOrgsFound ? (
            <Grid
              key="noOrgGrid"
              doubling
              stackable
              reversed="mobile"
              padded="vertically"
            >
              <Grid.Row>
                <Grid.Column>
                  <Segment basic textAlign="center">
                    <h2>You must first belong to an organization to see your grants.</h2>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : (
            <Grid
              key="orgGrantsGrid"
              doubling
              stackable
              reversed="mobile"
              padded="vertically"
            >
              <Grid.Row key="orgDropDown">{this.renderOrgDropdown()}</Grid.Row>
              <Grid.Row key="orgGrants">
                {sortReorder && (
                  <Grid.Column width={4}>{this.renderFilter()}</Grid.Column>
                )}
                {loading ? (
                  <Grid.Column width={12}>
                    <Loader inline="centered" active content="Loading" />
                  </Grid.Column>
                ) : (
                  this.renderGrants()
                )}
                {!sortReorder && (
                  <Grid.Column width={4}>{this.renderFilter()}</Grid.Column>
                )}
              </Grid.Row>
            </Grid>
          )}
        </Container>
      </Main>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getOrgById: (token, orgId) => {
      const action = ApiActions.organization.getOrganizationById(token, orgId);
      const response = dispatch(action);
      return response;
    },
    getOrgs: (token) => {
      const action = ApiActions.organization.getOrganizationsByCurrentUser(token);
      const response = dispatch(action);
      return response;
    },
    organizations: (orgIds, token) => {
      const action = ApiActions.organization.getOrganizationsListById(token, orgIds);
      const response = dispatch(action);
      return response;
    },
    getConfigByCategoryId: (token, entityType, entityId, configType, configId) => {
      let action = ApiActions.config.getConfig(
        token,
        entityType,
        entityId,
        configType,
        configId
      );
      const response = dispatch(action);
      return response;
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    toggles: state.toggles.toggles,
  };
};

const SubOrgGrants = connect(mapStateToProps, mapDispatchToProps)(_SubOrgGrants);

export default SubOrgGrants;
